<template>
  <div>
    <div class="text-h5 font-weight-bold mb-2">
      <span v-if="mode == 'login'">Connexion</span>
      <span v-else>Créer {{ account_wording[0] }}</span>
    </div>
    <p v-if="mode == 'login'">Connectez-vous à votre {{ account_wording[1] }} Sportips pour retrouver vos informations
      et suivi de vos
      inscriptions.</p>
    <p v-else>Créez {{ account_wording[0] }} pour retrouver vos informations et suivi de vos
      inscriptions.</p>
    <v-form ref="login_form">
      <label class="field_label">Email</label>
      <v-text-field class="my-1" v-model="user.mail" type="email"
        :rules="[$formRules.required, $formRules.email]"></v-text-field>
      <label class="field_label">Mot de passe</label>
      <v-text-field v-model="user.pass" :rules="passwordFieldRules" :type="showpass ? 'text' : 'password'"
        :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showpass = !showpass"></v-text-field>
      <PasswordPolicyHints v-if="mode == 'register'" :password="user.pass" />
      <div v-if="mode == 'register'">
        <label class="field_label">Confirmer votre mot de passe</label>
        <v-text-field v-model="password_confirm" :rules="[$formRules.required]"
          :type="showconfirmpass ? 'text' : 'password'" :append-icon="showconfirmpass ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showconfirmpass = !showconfirmpass"></v-text-field>
      </div>
      <v-alert color="dark-red" variant="tonal" density="compact" class="mb-2" v-if="error" type="error">{{ error
      }}</v-alert>
      <div class="d-flex justify-end mb-2" v-if="mode == 'login'">
        <router-link class="text-darkblue" :to="{ name: 'ForgottenPassword' }">Mot de passe oublié?</router-link>
      </div>
      <div v-if="mode == 'login'">
        <v-btn color="primary-dark" variant="tonal" size="large" class="mb-3" block @click="handleLogin">Se
          connecter</v-btn>
        <v-btn color="primary-dark" block size="large" variant="outlined" @click="mode = 'register'">Créer
          {{ account_wording[0] }}</v-btn>
      </div>
      <div v-else>
        <v-btn variant="tonal" color="primary-dark" size="large" class="mb-3" block
          @click="handleRegister">S'inscrire</v-btn>
        <v-btn color="primary-dark" block size="large" variant="outlined" @click="mode = 'login'">J'ai déjà {{
          account_wording[0] }}</v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PasswordPolicyHints from "@/components/Authentification/PasswordPolicyHints.vue";
export default {
  components: { PasswordPolicyHints },
  data() {
    return {
      mode: "login",
      showpass: false,
      showconfirmpass: false,
      error: "",
      password_confirm: "",
      user: {
        mail: "",
        pass: "",
      },
    };
  },
  computed: {
    ...mapStores(useMainStore),
    passwordFieldRules() {
      if (this.mode === "register")
        return [this.$formRules.required, this.$formRules.password];
      return [this.$formRules.required];
    },
    account_wording() {
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
      if (is_bicentenaire) {
        return ["un espace personnel", "espace personnel"];
      } else {
        return ["un compte", "compte"];
      }
    }
  },
  methods: {
    async handleLogin() {
      const { valid } = await this.$refs.login_form.validate();
      if (!valid) return;

      let request = await this.mainStore.authUser.login(this.user);
      if (request) {
        if (request.error) {
          this.mainStore.notification.send(request.error, "error");
        }
        else {
          this.mainStore.notification.send("Connexion réussie", "success");
        }
      } else {
        this.error = "Email ou mot de passe incorrect";
      }

    },
    async handleRegister() {
      const { valid } = await this.$refs.login_form.validate();
      if (!valid) return;
      if (this.password_confirm != this.user.pass) {
        this.error = "Les deux mots de passe sont différents";
        return;
      }
      let request = await this.mainStore.authUser.register(this.user);
      console.log(request);
      if (request.success) {
        this.mainStore.notification.send("Inscription réussie", "success");
      } else {
        this.error = request.error;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>